import { render, staticRenderFns } from "./LinkGridComponent.vue?vue&type=template&id=3473d85c&"
import script from "./LinkGridComponent.vue?vue&type=script&lang=js&"
export * from "./LinkGridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports